// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronRightSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8.9,8l-4.1,5h2.2l3.3-4.1L11.1,8l-0.8-0.9L7.1,3H4.9L8.9,8z" />
    </svg>
  );
};
